/*@ngInject*/
const RepeatingFormController = function () {
};

angular.module('ums.configuration')
    .controller('repeatingFormController', RepeatingFormController);
